import { render, staticRenderFns } from "./BatchHitReconComponent.vue?vue&type=template&id=20ddc246&"
import script from "./BatchHitReconComponent.vue?vue&type=script&lang=js&"
export * from "./BatchHitReconComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports